import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { GetLicenses as GetLicensesReducer } from '../../reducers/r_index';
import { MultiViewGestioneLicenze as MultiViewReducer } from '../../reducers/r_index';

import { CreateLicense as CreateLicenseReducer } from '../../reducers/r_index';
import { EditLicense as EditLicenseReducer } from '../../reducers/r_index';
import { EditDataScadenza as EditDataScadenzaReducer } from '../../reducers/r_index';
import { ManageModuli as ManageModuliLicenseReducer } from '../../reducers/r_index';

import { ManageStateLicense as ManageStateLicenseReducer } from '../../reducers/r_index';
import { UnlinkLicense as UnlinkLicenseReducer } from '../../reducers/r_index';

//Components
import ToolbarGestioneLicenzeCmp from '../../components/gestione_licenze/ToolbarGestioneLicenzeCmp';


class ToolbarGestioneLicenze extends React.Component {

    render() {
        const { ...props } = this.props;

        return (
            <ToolbarGestioneLicenzeCmp {...props} />
        );
    }
}

ToolbarGestioneLicenze.propTypes = {
    refreshListaLicenze: PropTypes.func.isRequired,
    changeViewSelection: PropTypes.func.isRequired,
    resetCreateLicense: PropTypes.func.isRequired,
    resetModuli: PropTypes.func.isRequired,

    selected_view: PropTypes.string.isRequired,
    selection: PropTypes.arrayOf(PropTypes.number),

    showEditDataScadDialog: PropTypes.func.isRequired,
    showGestioneStatoDialog: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => ({
    refreshListaLicenze: (codiceUtente) => { dispatch(GetLicensesReducer.creators.getLicensesRequest(codiceUtente)); },
    changeViewSelection: newView => dispatch(MultiViewReducer.creators.changeViewSelection(newView)),

    resetCreateLicense: () => { dispatch(CreateLicenseReducer.creators.resetCreateLicense()) }, 
    resetModuli: () => { dispatch(ManageModuliLicenseReducer.creators.resetModuli()) },
    resetEditLicenseData: () => { dispatch(EditLicenseReducer.creators.resetEditLicenseData()) },


    showEditDataScadDialog: () => { dispatch(EditDataScadenzaReducer.creators.showEditDataScadDialog()); },
    showGestioneStatoDialog: () => { dispatch(ManageStateLicenseReducer.creators.showGestioneStatoDialog()); },
    showDisassociaDialog: () => { dispatch(UnlinkLicenseReducer.creators.showDisassociaDialog()); },

});

const mapStateToProps = state => ({
    selection: state['filtro-licenze'].selection,
    selected_view: state['multi-view-gestione-licenze'].selected_view,

    codiceUtente: state['logged-user'].codiceUtente,
});

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarGestioneLicenze);
